<template>
  <div class="scrollTitle">
    <div @mouseenter="stopAnim" @mouseleave="revertAnim" class="wrapper">
      <ul :style="getTransform" class="titlelist">
        <li @click.stop="clickItem(item)" v-for="item in data">
          <p>{{item.title}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: "scrollTitle",
    data() {
      return {
        currentShowIdx: 0,
        timer: null
      }
    },
    props: {

      /***
       * data:传入的主数据[Array]
       * during:滚动时间间隔[Number]
       */

      data: {
        type: Array,
        default() {
          return [
            {
              title: "测试标题1",
              id: 1,
            },
            {
              title: "测试标题1",
              id: 2,
            },
            {
              title: "标题3标题3标题3标题3标题3",
              id: 3,
            },
            {
              title: "标题4标题4标题4标题4标题4",
              id: 4,
            },
            {
              title: "标题5标题5标题5标题5标题5",
              id: 5,
            }
          ];
        }
      },
      during: {
        type: Number,
        default: 3000,
      }
    },
    methods: {

      createAnim() {
        this.timer = setInterval(() => {
          if (this.currentShowIdx >= this.data.length - 1) {
            this.currentShowIdx = 0;
            return;
          }
          this.currentShowIdx++;
        }, this.during)
      },
      clearAnim() {
        clearInterval(this.timer)
      },
      stopAnim() {
        this.clearAnim();
      },
      revertAnim() {
        this.createAnim()
      },
      clickItem(item) {
        this.$emit("clickItem", item)
      }

    },
    computed: {
      getTransform() {
        return `transform:translateY(${-this.currentShowIdx * 18}px)`
      }
    },
    mounted() {
      this.createAnim()
    },
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .scrollTitle

    .wrapper
      /*border 1px solid #00f*/
      height 18px
      overflow hidden

      .titlelist
        transition 300ms

        li
          line-height 18px

          p
            font-size 14px
            color #666666
            transition 300ms
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            &:hover
              color #333333
              text-shadow 2px 2px 2px #cccccc

</style>



// WEBPACK FOOTER //
// src/components/globalComp/scrollTitle.vue